import Logo from '@atom/components/common/navigation/Logo';
import { useNavigation } from '@atom/hooks/useNavigation';
import { usePreferences } from '@atom/hooks/usePreferences';
import { Button, Icon } from '@atom/mui';
import { BrokenImageIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { getPortals } from '@atom/utilities/portalUtilities';

import classes from './errorPages.module.css';

const styles = {
  icon: {
    fontSize: '75px',
    backgroundColor: colors.neutral.silver,
    borderRadius: '10px',
  },
  button: {
    marginTop: '2rem',
  },
};

const NotFound = () => {
  const [, { Link }] = useNavigation();
  const preferences = usePreferences();
  const landingPortal = getPortals(preferences)[preferences.landingPortal];

  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <Logo />
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <Icon
            style={styles.icon}
            color={colors.neutral.white}
            icon={BrokenImageIcon}
          />
          <div className={classes.title}>Page Not Found</div>
          <div className={classes.subtext}>
            We're sorry. The page you requested can not be found.
          </div>
          <div className={classes.subtext}>
            Please go to the homepage or contact support.
          </div>
          <Link to={landingPortal.urlPath} style={styles.button}>
            <Button variant="contained" color="primary">
              Go To Homepage
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
